import cn from 'classnames'
import * as React from 'react'
import * as iconGlyphs from '../../glyphs'
import styles from './Icon.module.css'
import { IconProps } from './Icon.types'

export type IconGlyph = keyof typeof iconGlyphs

type IconCSSProperties = React.CSSProperties & {
  '--_icon-size'?: string
}

function Icon({ className, glyph, size = 24, fullWidth = false, ...rest }: IconProps) {
  const GlyphComponent = iconGlyphs[glyph]

  const mergedStyles: IconCSSProperties = { '--_icon-size': `var(--icon-size, ${size}px)` }

  return (
    <span
      className={cn(
        styles.icon,
        { [styles.fullWidth]: fullWidth },
        className,
      )}
      style={mergedStyles}
    >
      <GlyphComponent {...rest} />
    </span>
  )
}

Icon.displayName = 'Icon'

export default Icon
